export var hasProtocol = function hasProtocol(str) {
  return /^https?:\/\//.test(str);
};